<template>
    <div class="about">
        <div class="ecosystem">
            <!-- 证书 -->
            <div class="cate">
                <img src="../../assets/image/证书.png">
            </div>
            <!-- 新生态 -->
            <Title :title="context['新生态'].title ? context['新生态'].title : '矢量，构筑企业数字化新生态'" 
                   :content="context['新生态'].content ? context['新生态'].content : '以自研数字孪生平台PONGO为核心，为企业提供全生命周期的数字化应用解决方案，助力企业在数字化时代的转型升级。'"></Title>
            <div class="ecosystem_frame">
                <div class="frame_container">
                    <div v-for="(item, index) in context['新生态'].item ? context['新生态'].item : frameContent" :key="index" :class="['frame_item',index===1 ? 'two' : '', index===2 ? 'one' : '']">
                    <div class="item_container">
                        <div class="inner">
                            <p class="title">{{ item.title }}</p>
                            <p class="content">{{ item.content }}</p>
                        </div>
                        <!-- <p class="content">{{ item.content2 }}</p> -->
                    </div>
                </div>
                </div>
            </div>
            <!-- 服务优势 -->
            <Title :title="context['服务优势'].title ? context['服务优势'].title : '服务优势'" 
                   :content="context['服务优势'].content ? context['服务优势'].content : '利用三维数字化技术，实现项目从数字化映射到决策自洽全生命周期解决方案'"></Title>
            <div class="server">
                <div class="left">
                    <div class="top">
                        <p class="title">定位</p>
                        <p class="content">为企业提供专业的</p>
                        <p class="content">应用数字技术解决方案</p>
                    </div>
                    <div class="bottom">
                        <p class="title">目标</p>
                        <p class="content">成为企业伙伴的事业共同体</p>
                    </div>
                </div>
                <div class="mid">
                    <img src="../../assets/image/资源 193.png">
                </div>
                <div class="right">
                    <p class="title">差异化&价值</p>
                    <ul>
                        <li v-for="(item, index) in difference" :key="index">
                            <p class="small_title">{{ item.small_title }}</p>
                            <p class="content">{{ item.content }}</p>
                            <p class="content">{{ item.content2 }}</p>
                        </li>
                    </ul>
                </div>
            </div>
        </div>
        <!-- 联系我们 -->
        <div class="contact" id="contact">
            <!-- <Title :title="titleAbout[2].title" :content="titleAbout[2].content"></Title> -->
            <div class="map_container" id="map_container"></div>
            <div class="map_mask map_mask_top">
                <div class="title_container">
                    <p style="font-family: AliMedium; font-size: 2rem; color: #fff; padding: 3rem 0 1.2rem 0;">{{ context['联系我们'].title ? context['联系我们'].title : '联系我们' }}</p>
                    <p style="font-family: AliRegular; font-size: 1rem; color: #fff; padding-bottom: 1.2rem;">{{ context['联系我们'].content }}</p>
                    <div class="bar_container">
                        <div class="title_bar bar_inner"></div>
                        <div class="title_bar bar_outer"></div>
                    </div>
                </div>
            </div>
            <div class="map_mask map_mask_bottom">
                <div class="call_container">
                    <div :class="['call', index!==3 ? 'call_border' : '']" v-for="(item, index) in callArray" :key="index">
                        <div class="call_icon">
                            <img :src="item.icon">
                        </div>
                        <div class="call_item">
                            <p style="color: #FFF; font-size: 0.85rem; line-height: 1.21rem;">{{ item.name }}</p>
                            <p style="color: #FFF; font-size: 0.85rem; line-height: 1.21rem;">{{ item.content }}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- 新闻 -->
        <div class="news">
            <Title :title="context['新闻动态'].title ? context['新闻动态'].title : '新闻动态'" :content="context['新闻动态'].content"></Title>
            <div class="news_frame" v-if="newsArrayItem.length">
                <div class="news_container" v-for="(item, index) in newsArrayItem" :key="index">
                    <div class="news_title">
                        <div class="circle"></div>
                        <div class="time">{{ item.publishAt }}</div>
                        <div class="title" style="cursor: pointer;" @click="goDetail(item.id)">{{ item.title }}</div>
                    </div>
                    <div class="content">
                        <div class="image">
                            <img :src="item.imageUrl" @click="goDetail(item.id)" style="width: 26.31rem; height: 12.06rem; cursor: pointer; object-fit: cover; object-position: center; padding-left: 2.5rem;">
                        </div>
                        <div class="context">
                            <p class="content">{{ item.content }}</p>
                            <p class="detail" @click="goDetail(item.id)">查看详情></p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="news_frame no_border" v-else>
                <p>暂无新闻</p>
            </div>
            <div class="news_pagination">
                <el-pagination
                    :current-page="currentElPage"
                    :total="total"
                    @current-change="currentChange"
                    @size-change="sizeChange"
                    :page-size="size"
                    :hide-on-single-page="value"
                    background
                    layout="prev, pager, next"
                    >
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
import { getText, getNews } from "../../util"
import { fromDictToArray } from "../../util/tool"
import  Title  from '../../components/title/index.vue'
import { titleAbout } from '../../util/constant'
import AMapLoader from '@amap/amap-jsapi-loader'
export default {
    data() {
        return {
            totalPages:0, // 新闻页数
            currentElPage:0, // 当前页数
            value:false,
            arrayIndex:0, // 第几组
            titleAbout,
            frameContent:[
                {
                    title:'数字化映射',
                    content:'数字孪生要对物理空间进行精准的数字化复现并通过物联网实现物理空间与数字空间之间的虚实互动。',
                },
                {
                    title:'分析诊断',
                    content:'将数据驱动模型融入物理世界的精准仿真数字模型中，对物理空间进行全周期的动态监控，构建各类可复用的功能模块，对所涉数据进行分析、理解，并对已发生或即将发生的问题做出诊断、预警及调整，实现对物理世界的状态跟踪、分析和问题诊断等功能。',
                },
                {
                    title:'自我学习',
                    content:'数字孪生能通过将感知数据的分析结果与动态行业词典 相结合进行自我学习更新，并根据已知的物理对象运行 模式，在数字空间中预测、模拟并调试潜在未发觉 的及未来可能出现的物理对象的新运行模式。',
                },
                {
                    title:'决策自洽',
                    content:'具有“中枢神经”处理功能的模块则通过对各类智能 推理结果的进一步归集、梳理与分析，实现对物理 世界复杂状态的预判，并自发地提出决策性建议 和预见性改造，并根据实际情况不断调整和完善 自身体系。',
                }
            ],
            callArray:[
                {name: 'Tel', content: '400-8766-576', icon: require('../../assets/image/资源 244.png')},
                {name: 'Email', content: 'admin@vp3d.cn', icon: require('../../assets/image/资源 242.png')},
                {name: 'QQ', content: '726991510', icon: require('../../assets/image/资源 241.png')},
                {name: 'Add', content: '青岛市市北区周口路97号中航科技园', icon: require('../../assets/image/资源 243.png')}
            ],
            difference:[
                {
                    small_title:"1)技术、业务垂直一体化：聚焦专业 延展行业",
                    content:'深耕行业，了解行业规律，触达企业业务本质',
                    content2:'基于客户特点，提出更有建设性的解决方案'
                },
                {
                    small_title:"2)实施一体化：调研、执行整体解决方案",
                    content:'提供数字孪生中后期全流程一体化执行团队',
                    // content2:'基于客户特点，提出更有建设性的解决方案'
                },
                {
                    small_title:"3)对数字孪生更了解",
                    content:'自研平台——PONGO数字孪生平台，协助企业快速搭建',
                    content2:'数字孪生平台'
                },
                {
                    small_title:"4)绑定式合作，更放心",
                    content:'成为企业的事业合作共同体，与企业共发展',
                    // content2:'基于客户特点，提出更有建设性的解决方案'
                }

            ],
            newsArray:[],
            newsArrayItem:[],
            news:{
                time:'2024-02-28',
                title:'数字孪生，青岛数字孪生',
                image:require('../../assets/image/资源 210.png'),
                context:'早期的HarmonyOS操作系统是基于Linux内核，和Android使用的同一个内核，iOS使用的是Unix内核。Linux内核早期定位是面向服务器设备的，编译过程十分复杂，内存机制可以说是一塌糊涂要想构建一个优秀的操作系统，除了上层的开发框架、开发语言、编译器等内容外，内核是操作系统的重中之重。因此HarmonyOS从Next版本，即星河版开始，转而采用原生的鸿蒙内核，真正去打造面向消费者终端的原生内核'
            },
            context: {
                '新生态':{},
                '服务优势':{},
                '联系我们':{},
                '新闻动态':{}
            },
            size: 5,
            total: 0,
        }
    },
    components: {
        Title
    },
    methods: {
        getNewsList(){
            let obj = {
                size: this.size,
                current: this.currentElPage
            }
            let token = window.localStorage.getItem('userToken')
            getNews(obj, token).then(res=>{
                if(res.code === 200){
                    this.newsArrayItem = res.data.records
                    this.total = res.data.total
                }
            })
        },
        initMap(){
            window.mapSecurityConfig = {
                securityJsCode:'603b979b54e48d3a6f6125ca50814c19'
            }
            let that = this;
            AMapLoader.load({
                "key": "044783bb5165cb0f1c6dd253c488c858",// 申请好的Web端开发者Key，首次调用 load 时必填
                "version": "2.0",// 指定要加载的 JSAPI 的版本，缺省时默认为 1.4.15
                "plugins": [],// 需要使用的的插件列表，如比例尺'AMap.Scale'等
            }).then((AMap) => {
                that.Map = new AMap.Map('map_container', {
                    mapStyle:'amap://styles/normal', //设置地图的显示样式
                    zoom: 13,//设置初始化级别
                    zooms: [5, 30], //设置缩放级别范围 10-15 级
                    center: [120.395534, 36.139778],//中心点
                });
                 // 点标记显示内容，HTML要素字符串
                var markerContent = '' +
                    '<div class="custom-content-marker">' +
                    '   <img src="../../assets/image/15.查看详情.png") style="width:1rem">' +
                    '</div>';
                const icon = new AMap.Icon({
                    size: new AMap.Size(21, 26),  // 图标尺寸
                    image: require('../../assets/image/资源 205.png'),  // Icon的图像
                    imageSize: new AMap.Size(21, 26),   // 根据所设置的大小拉伸或压缩图片
                    imageOffset: new AMap.Pixel(0, 0), // 图像相对展示区域的偏移量，适于雪碧图等
                })
                const marker = new AMap.Marker({
                    position: new AMap.LngLat(120.395534, 36.139778),
                    title: '青岛矢量数字科技有限公司',
                    icon: icon, // 添加 Icon 实例
                    // content: markerContent,
                })
                const infoWindow = new AMap.InfoWindow({
                    anchor: 'bottom-center',
                    content: '<div class="info-window_name" style="color: #54ceec">● 青岛矢量数字科技有限公司</div><div class="info-window" style="margin-top: 4px;">地址：山东省青岛市市北区周口路97</div><div class="info-window" style="margin-top: 4px;">号中航工业青岛科技园36号楼</div>',
                    offset: new AMap.Pixel(10, -8)
                })
                // marker.on("click", function(e) {
                    infoWindow.open(that.Map, [120.395534, 36.139778])
                // })
                that.Map.add(marker);
            }).catch(e => {
                console.log(e);
            })
        },
        currentChange(page){
            this.currentElPage = page
            this.getNewsList()        },
        sizeChange(val){
            this.size = val
            this.getNewsList()
        },
        prevClick(){
            if(this.currentElPage == 1 ){
                return
            }
            this.currentElPage--
            this.newsArrayItem = this.newsArray.slice((this.currentElPage-1)*8,this.currentElPage*8)
            // this.industrialModel = industrialModels.slice(8, 16)
        },
        nextClick(){
            // 向上取整
            let total = Math.ceil(this.totalModels/5)
            if(this.currentElPage === total || this.currentElPage > total){
                return
            }
            this.currentElPage++
            this.newsArrayItem = this.newsArray.slice((this.currentElPage-1)*8,this.currentElPage*8)
            // this.industrialModel = industrialModels.slice(0, 8)
        },
        goDetail(id){
            // 新页面打开
            window.open(`/news?id=${id}`, '_blank')
        }
    },
    mounted() {
        this.initMap()
        this.getNewsList()
        let page = '关于矢量'
        getText(page).then(res=>{
            if(res.code === 200) {
                this.context['新生态'] = res.data[0]
                this.context['新生态'].item = fromDictToArray(res.data[0])
                this.context['服务优势'] = res.data[1]
                // this.context['行业痛点'].item = fromDictToArray(res.data[1])
                this.context['联系我们'] = res.data[2]
                // this.context['新闻动态'].item = fromDictToArray(res.data[2])
                this.context['新闻动态'] = res.data[3]
            }   
        })
    },
    beforeMount(){
        // 将news循环100遍放入newsArray中
        for(let i=0;i<100;i++){
            this.newsArray.push(this.news)
        }
        this.pageNumber = this.newsArray.length/6
    }
}
</script>

<style scoped lang="less">
.amap-info-content{
    .info-window{
        color: #54ceec;
    }
}
.about{
    background-color: #000;
    .ecosystem{
        background-image: url('../../assets/image/资源 271-8.png');
        background-size: cover;
        .ecosystem_frame{
            max-width: 1403px;
            margin: 3rem auto;
            height: 21.6rem;
            display: flex;
            background-image: url('../../assets/image/资源 295.png');
            .frame_container{
                display: flex;
                justify-content: center;
                // background-color: #54ceec;
                width: 100%;
                margin: 0 auto;
            }
            .frame_item{
                // background-color: coral;
                // height: 60%;
                width: 33%;
                display: flex;
                justify-content: center;
                // margin-left: 10%;
                .item_container{
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    align-items: center;
                    .inner{
                        display: flex;
                        flex-direction: column;
                        height: 60%;
                        /* justify-content: center; */
                        align-items: center;
                    }
                    .circle{
                        width: 5rem;
                        height: 5rem;
                        border-radius: 90%;
                        background-color: #357279;
                        position: relative;
                        margin-bottom: 1rem;
                        .number{
                            position: absolute;
                            top: 50%;
                            left: 50%;
                            color: #fff;
                            font-size: 2rem;
                            transform: translate(-50%, -50%);
                        }
                    }
                    .title{
                        color: #54ceec;
                        font-size: 2rem;
                        padding: 27px 0 12px;
                    }
                    .content{
                        color: #fff;
                        letter-spacing: 1px;
                        margin-top: 1.5rem;
                        padding: 0 105px;
                        line-height: 22px;
                    }
                }
            }
        }
        .server{
            width: 80%;
            min-width: 1350px;
            // height: 5rem;
            display: flex;
            justify-content: center;
            margin: 3rem auto 5rem;
            .left{
                width: 33%;
                // background-color: green;
                display: flex;
                flex-direction: column;
                text-align: end;
                flex-wrap: wrap;
                .top, .bottom{
                    height: 50%;
                    .title{
                        color: #54ceec;
                        font-size: 2.2rem;
                        font-family: AliMedium;
                        padding: 1rem 0 2rem 0;
                    }
                    .content{
                        color: #fff;
                        font-size: 1.39rem;
                        font-family: AliMedium;
                        line-height: 2rem;
                    }
                }
            }
            .mid{
                width: 33%;
                // background-color: rgb(255, 181, 249);
                display: flex;
                justify-content: center;
                align-items: center;
                // background-image: url('../../assets/image/资源\ 193.png');
            }
            .right{
                width: 33%;
                // background-color: green;
                display: flex;
                flex-direction: column;
                text-align:left ;
                .title{
                    color: #54ceec;
                    font-size: 2rem;
                    font-family: AliMedium;
                    padding: 1rem 0 2rem 0;
                }
                ul li{
                    padding: 1rem 0;
                    .small_title{
                        color: #fff;
                        font-size: 1.39rem;
                        font-family: AliMedium;
                        // padding-bottom: 0.5rem;
                    }
                    .content{
                        color: #979797;
                        font-size: 0.85rem;
                        line-height: 1.33rem;
                        font-family: AliMedium;
                    }
                }
            }
        }
        .cate{
            width: 100%;
            margin-bottom: 32px;
            img{
                width: 100%;
            }
        }
    }
    .contact{
        height: 60rem;
        width: 100%;
        position: relative;
        .map_container{
            width: 100%;
            height: 100%;
            position: absolute;
            // z-index: 9999;
        }
        .map_mask{
            position: absolute;
            background-color: #000000b3;
            opacity: 0.8;
            height: 18%;
        }
        .map_mask_top{
            width: 100%;
            .title_container{
                text-align: center;
                // background-color: #83f26f;
                // padding-bottom: 1rem;
                .bar_container{
                    position: relative;
                    // height: 20px;
                    // padding-top: 3%;
                    margin-bottom: 3rem;
                }
                .title_bar{
                    position: absolute;
                    top: 50%;
                    // transform: translateY(-50%);
                    left: 50%;
                    transform: translate(-50%,-50%);
                }
                .bar_outer{
                    height: 2px;
                    width: 3.5rem;
                    background-color: #54ceec;
                    // left: 48.5%; /* 根据长线的宽度调整负边距，使两条线居中重合 */
                }
                .bar_inner{
                    height: 2px;
                    width: 9.75rem;
                    background-color: rgb(161, 161, 161);
                    // left: 46%; /* 根据长线的宽度调整负边距，使两条线居中重合 */
                }
            }
        }
        .map_mask_bottom{
            width: 100%;
            height: 20%;
            bottom: 0;
            display: flex;
            justify-content: space-around;
            align-items: center;
            .call_container{
                display: flex;
                width: 60%;
                padding-top: 1rem;
                align-items: flex-start;
                .call{
                    width: 25%;
                    padding: 0 3%;
                    // background-color: #54ec6d;
                    display: flex;
                    align-items: center;
                    justify-content: center;
                    .call_icon{
                        margin-right: 1rem;
                    }
                    // .call_item{
                        // display: flex;
                    // }
                }
                .call_border{
                    border-right: 1px solid #999999;
                }
            }
        }
        .map_mask_left{
        width: 30%;
        height: 34%;
        top: 33%;
        left: 0;
        }
        .map_mask_right{
            width: 30%;
            height: 34%;
            top: 33%;
            right: 0;
        }
    }
    .news{
        // background-color: coral;
        width: 80%;
        min-width: 1350px;
        margin: 0 auto;
        .news_frame{
            border-left: 2px dashed #E9E9EA;
            width: 90%;
            margin: 2rem auto 0;
            padding: 0.3rem 2rem;
            .news_container{
                margin-bottom: 5rem;
            }
            .news_title{
                display: flex;
                align-items: center;
                margin-bottom: 2rem;
                .circle{
                    width: 0.81rem;
                    height: 0.81rem;
                    border-radius: 90%;
                    background-color: #54ceec;
                }
                .time{
                    color: #54ceec;
                    margin: 0 1rem;
                    font-size: 1.21rem;
                }
                .title{
                    color: #DBDBDB;
                    font-size: 1.33rem;
                    // font-weight: 500;
                }
                // .time::before{
                //     width: 20px;
                //     height: 20px;
                //     border-radius: 90%;
                //     background-color: #54ceec;
                // }
            }
            .content{
                display: flex;
                .context{
                    padding: 0rem 2rem;
                    display: flex;
                    flex-direction: column;
                    justify-content: center;
                    height: 12.06rem;
                    width: 45rem;
                    background-color: #161616;
                    .content{
                        color: #979797;
                        // align-items: center;
                        font-size: 0.85rem;
                        line-height: 1.33rem;
                        // padding: 0 4rem 0 0;
                    }
                    .detail{
                        font-size: 0.73rem;
                        margin-top: 0.8rem;
                        line-height: 1.33rem;
                        color: #54ceec;
                        cursor: pointer;
                    }
                }
            }
        }
        .no_border{
            border: none;
            width: 90%;
            margin: 2rem auto 0;
            color: #DBDBDB;
            text-align: center;
        }
        .news_pagination{
            display: flex;
            justify-content: center;
            padding: 2rem 0 5rem;
        }
    }
}
::v-deep .el-pagination.is-background .btn-next, ::v-deep .el-pagination.is-background .btn-prev, ::v-deep .el-pagination.is-background .el-pager li{
    background-color: #8C8C8C;
    color: #fff;
}

::v-deep .el-pagination.is-background .el-pager li:not(.disabled).active{
    background-color: #54ceec;
    color: #000;
}
::v-deep .el-pagination.is-background .el-pager li:not(.disabled):hover{
    color: #000;
}
</style>